import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  Encounter,
  EncounterParticipant,
} from "@dndModels";

import API from "@dndUtilities/system_api";
// import CharacterUtilities from "../../utilities/character_utilities";
import CommonUtilities from "@utilities/common_utilities";

import CharacterParticipant from "@dndComponents/encounter/CharacterParticipant";
import PageLinks from "@components/Navigation/PageLinks";
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

interface Props { 
  obj: Encounter;
  characters: Character[];
  filter: any;
  change_time: number;
  color: string;
  onChange: (changed: Encounter) => void;
}

const api = API.getInstance();
// const char_util = CharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function AddCharacterParticipants({ 
  obj,
  characters,
  filter,
  change_time,
  color,
  onChange
}: Props) {
  const [myObj, setObj] = useState(obj);
  const [page_num, setPageNum] = useState(0);
  const [prev_filter, setFilter] = useState<any>({});
  const [adding_characters, setAddingCharacters] = useState<Character[]>([]);
  const [prev_change_time, setPrevChangeTime] = useState(0);

  useEffect(() => {
    if (!common_util.objectsMatch(filter, prev_filter)) {
      setFilter(filter);
      setPageNum(0);
    }
  }, [filter, prev_filter, setFilter, setPageNum]);

  useEffect(() => {
    if (change_time !== prev_change_time) {
      setPrevChangeTime(change_time);
    }
  }, [change_time, prev_change_time]);

  const addCharacters = () => {
    let add_time = common_util.get_time_number();
    for (const adding_character of adding_characters) {
      const new_participant = new EncounterParticipant();
      new_participant.participant = adding_character;
      new_participant.participant_id = adding_character._id;
      new_participant.owner_id = adding_character.owner_id;
      new_participant.participant_type = "Character";
      new_participant.color = color;
      new_participant.add_time = add_time;
      add_time++;
      myObj.participants.push(new_participant);
    }
    updateEncounter(myObj, true);
  }

  const updateEncounter = (changed: Encounter, clear_adding = false) => {
    setObj(changed);
    if (clear_adding) {
      setAddingCharacters([]);
    }
    onChange(changed);
  } 

  const renderAddingCharacters = () => {
    if (adding_characters.length > 0) {
      const adding_characters_string = adding_characters.map(char => char.name).join(", ");
      return (
        <Grid container spacing={0} direction="row">
          <Grid size={2}>Adding</Grid>
          <Grid size={8}>{ adding_characters_string }</Grid>
          <Grid size={2}>
            <DandDButtonBox
              name="Add"
              onClick={addCharacters}
            />
          </Grid>
        </Grid>
      );
    }
    return null;
  }

  const page_size = 5;
  const objects = characters;
  // console.log(objects);
  // console.log(filter);
  let filtered = api.filter("character", objects, filter) as Character[];
  filtered = filtered.sort((a,b) => { 
    if (a.character_level === b.character_level) {
      return a.name.trim().localeCompare(b.name.trim()); 
    } else {
      return +a.character_level < +b.character_level ? -1 : 1;
    }
  });
  
  const page_count = Math.ceil(filtered.length / page_size);
  const filtered_and_paged = filtered.slice(page_size * page_num, page_size * (page_num + 1));
  
  return (
    <Grid
      container
      spacing={0}
      direction="row"
      size={{
        xs: 12
      }}>
      { filtered_and_paged.map(char => {
        const adding = adding_characters.filter(o => o._id === char._id).length > 0;
        return (
          <Grid
            key={char._id}
            size={{
              xs: 12
            }}>
            <CharacterParticipant
              in_encounter={obj.participants.filter(o => o.participant_id === char._id).length > 0}
              character={char}
              char_id={char._id}
              adding={adding}
              onChange={(changed: boolean) => {
                if (changed !== adding) {
                  if (changed) {
                    setAddingCharacters([...adding_characters,char]);
                  } else {
                    setAddingCharacters(adding_characters.filter(o => o._id !== char._id));
                  }
                }
              }}
            />
          </Grid>
        );
      }) }
      <Grid
        size={{
          xs: 12
        }}>
        <PageLinks selected={page_num} page_count={page_count} onChange={setPageNum} />
      </Grid>
      <Grid size={12}>
        { renderAddingCharacters() }
      </Grid>
    </Grid>
  );
}